var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex text-right mr-5"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.__('company.components.tasks.index.day-total-hours.title')))]),_c('span',{domProps:{"textContent":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }